export const View = {
  VIEW_CREATIVES: 'VIEW_CREATIVES',
  ADD_CREATIVE: 'ADD_CREATIVE',
};
